import { CButton, CCard, CCardBody, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter, CFormLabel, CFormSelect, CFormInput, CFormText, CFormCheck } from '@coreui/react'
import React from 'react'
import { useState, useRef } from 'react'
import CustomAgGrid from './../../components/shared/CustomAgGrid'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'
import SaveDiagnosisData from '../../services/general/saveDiagnosisData.api'
import DeleteDiagnosis from '../../services/general/deleteDiagnosis.api'
import { Form } from '@formio/react'
import FacilityCRUD from '../../services/general/getFacilityData.api.js'
import ApplicationTypeFn from '../../services/general/modifyApplicationType.api.js'

import axios from 'axios'
import { useEffect } from 'react'
import CustomDropdown from './../../components/shared/CustomDropdown'
import Pageloader from '../../components/shared/Pageloader'

const ApplicationType = () => {
  const update = useRef('EDIT')
  const facilityID = useRef('-1')
  const [options, setOptions] = useState(['square', 'triangle', 'circle', 'pentagon', 'pin', 'H', 'E', 'S', 'A', 'I', 'M', 'N', 'T', 'X'])
  const [selected, setSelected] = useState(options[0])
  const [extra, setExtra] = useState('')
  const allVPN = ['Yes', 'No']
  const [vpn, setVPN] = useState(allVPN[0])
  const allLoginType = ['Standard', 'Customized']
  const [loginType, setLoginType] = useState(allLoginType[0])
  const [isPageLoading, setIsPageLoading] = useState(false)

  const onSelect = (e) => {
    const newValue = e.target.value

    setSelected(newValue)
  }
  const updateFacility = async (type, e) => {
    facilityID.current = e.id
    update.current = type
    if (type == 'DELETE') {
      let a = await callFn('DELETE', { id: e.id, name: e.Name })
      await getData()
    } else if (type == 'EDIT') {
      setInputValue(e.name)
      setApplicationURL(e.link)
      setButtonID(e.buttonid)
      setLoginID(e.loginid)
      setpasswordID(e.passwordid)
      setExtra(e.Extra)
      setLoginType(e.Login ? e.Login : allLoginType[0])
      setVPN(e.VPN ? e.VPN : allVPN[0])
      setModalVisible((e) => !e)
    }
  }

  const buttonList = [{ Name: 'Edit', FunctionName: updateFacility }]
  const [diagnosisData, setDiagnosisData] = useState('')
  const [selectedValue, setSelectedValue] = useState('')

  const [modalVisible, setModalVisible] = useState(false)
  const [inputValue, setInputValue] = useState('')
  const [applicationURL, setApplicationURL] = useState('')
  const [loginID, setLoginID] = useState('')
  const [passwordID, setpasswordID] = useState('')
  const [buttonID, setButtonID] = useState('')

  const facilityName = useRef('')

  const handleonClick = (e) => {
    update.current = 'INSERT'
    setInputValue('')
    setApplicationURL('')
    setLoginID('')
    setButtonID('')
    setpasswordID('')
    setVPN('')
    setLoginType('')
    setExtra('')
    setModalVisible((e) => !e)
  }

  const saveFacility = async () => {
    let name = inputValue
    let link = applicationURL
    let a = await callFn(update.current, { id: facilityID.current, name, link, loginID, passwordID, buttonID })
    await getData()
    setModalVisible(false)
  }

  const callFn = async (type, obj) => {
    let c = await ApplicationTypeFn(type, obj.id, obj.name, obj.link, loginID, passwordID, buttonID, vpn, loginType, extra)
    return c
  }

  const getData = async () => {
    setIsPageLoading(true)
    try {
      let a = await callFn('SELECT', { id: '', name: '', link: '' })
      let data = JSON.parse(a.d)
      setDiagnosisData(a.d)
    } catch (error) {
      console.log(error)
    } finally {
      setIsPageLoading(false)
    }
  }

  const [theme, setTheme] = useState(() => localStorage.getItem('provio_theme') || 'dark')

  useEffect(() => {
    getData()
    const handleThemeChange = () => {
      setTheme(localStorage.getItem('provio_theme') || 'dark')
    }
    window.addEventListener('provio-theme-change', handleThemeChange)
    return () => {
      window.removeEventListener('provio-theme-change', handleThemeChange)
    }
  }, [])

  return (
    <div className="position-relative patient-theme-page facility-type-theme" data-theme={theme}>
      <div className={`patient-page-wrapper page-wrapper patient-theme-shell ${theme === 'dark' ? 'dashboard-dark-theme' : ''}`}>
        <Pageloader isLoading={isPageLoading} />
        <CCard className="m-2 facility-type-theme__toolbar">
          <CCardBody className="facility-type-theme__toolbar-body">
            <CButton 
              className="m-2" 
              onClick={handleonClick}
              style={{
                backgroundColor: 'var(--ui-color-primary, #2b7cd3)',
                borderColor: 'var(--ui-color-primary, #2b7cd3)',
                color: 'white',
              }}
            >
              + Add Application Link
            </CButton>
          </CCardBody>
        </CCard>

        <div className="facility-type-theme__grid">
          <CustomAgGrid rowClickedFn={updateFacility} callFrom="Facility" options={diagnosisData} btnList={buttonList}></CustomAgGrid>
        </div>

        <CModal 
          size="md" 
          backdrop={'static'} 
          visible={modalVisible} 
          onClose={() => setModalVisible(false)}
          className="dashboard-dark-modal patient-theme-modal facility-type-theme__modal"
          data-theme={theme}
        >
          <CModalHeader onClose={() => setModalVisible(false)}>
            <CModalTitle>Add Application</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <div className="mb-3">
              <CFormLabel>Application Name</CFormLabel>
              <CFormInput value={inputValue} onChange={(e) => setInputValue(e.target.value)} />
            </div>
            <div className="mb-3">
              <CFormLabel>Link</CFormLabel>
              <CFormInput value={applicationURL} onChange={(e) => setApplicationURL(e.target.value)} />
            </div>
            <div className="mb-3">
              <CFormLabel>UserName ID</CFormLabel>
              <CFormInput value={loginID} onChange={(e) => setLoginID(e.target.value)} />
            </div>
            <div className="mb-3">
              <CFormLabel>Password ID</CFormLabel>
              <CFormInput value={passwordID} onChange={(e) => setpasswordID(e.target.value)} />
            </div>
            <div className="mb-3">
              <CFormLabel>Button ID</CFormLabel>
              <CFormInput value={buttonID} onChange={(e) => setButtonID(e.target.value)} />
            </div>
            <div className="mb-3">
              <CFormLabel>Extra</CFormLabel>
              <CFormInput value={extra} onChange={(e) => setExtra(e.target.value)} />
            </div>
            <div className="mb-3">
              <CFormLabel>VPN Required?</CFormLabel>
              <CustomDropdown
                options={allVPN}
                onSelect={(e) => {
                  setVPN(e.target.value)
                }}
                selected={vpn}
              ></CustomDropdown>

              {/* <CFormInput value={buttonID} onChange={(e) => setButtonID(e.target.value)}   /> */}
            </div>
            <div className="mb-3">
              <CFormLabel>Type of Login</CFormLabel>
              <CustomDropdown
                options={allLoginType}
                onSelect={(e) => {
                  setLoginType(e.target.value)
                }}
                selected={loginType}
              ></CustomDropdown>

              {/* <CFormInput value={buttonID} onChange={(e) => setButtonID(e.target.value)}   /> */}
            </div>
          </CModalBody>
          <CModalFooter>
            <CButton color="secondary" onClick={() => setModalVisible(false)}>
              Close
            </CButton>
            <CButton 
              color="primary" 
              onClick={() => saveFacility()}
              style={{
                backgroundColor: 'var(--ui-color-primary, #2b7cd3)',
                borderColor: 'var(--ui-color-primary, #2b7cd3)',
                color: 'white',
              }}
            >
              Save Changes
            </CButton>
          </CModalFooter>
        </CModal>
      </div>
    </div>
  )
}

const AddButton = () => {
  return (
    <>
      <CButton style={{ marginLeft: '10px' }} variant="outline" color="success">
        ADD +
      </CButton>
    </>
  )
}

export default ApplicationType
